import * as React from 'react'
import EmployeeEditor from './employee-editor'

interface EmployeeProjectEditorProps{
    companyId: string,
    projectId: string,
    placeholder?: string,
    value?: number,
    onChange?: (value: number) => void
}
interface EmployeeProjectEditorState {
    employeeId: number | undefined,
}

class EmployeeProjectEditor extends React.Component<EmployeeProjectEditorProps, EmployeeProjectEditorState> {

    constructor(props: EmployeeProjectEditorProps) {
        super(props);
        this.state = {
            employeeId: props.value
        }
    }

    public render() {
        var filter = {
                   
                };
        
        return (<EmployeeEditor
            placeholder={this.props.placeholder}
            companyId={this.props.companyId}
            excludeProjectMembers={this.props.projectId}
            nullable
            multiple
            value={this.state.employeeId as any}
            onChange={(item: any) => { if (this.props.onChange) { this.props.onChange(item && item.id ? item.id : item as any || undefined) } }}
        />);
    }
}

export default EmployeeProjectEditor